// components/ui/FullPageLoader.tsx

export default function FullPageLoader() {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        <div className="h-12 w-12 border-4 border-[#1B5C29] border-b-transparent rounded-full animate-spin" />
      </div>
    );
  }
  